import { useEffect, useState } from 'react'
import api from '../../../api'
import { useDispatch } from 'react-redux'
import { setLocationInfo } from '../../../actions/dsl-dive-center-actions'

export default function useLocationBounds(isNearBy, notNearByBounds) {
  const dispatch = useDispatch()
  const [bounds, setBounds] = useState(null)

  useEffect(() => {
    if(isNearBy) {
      api('/api/v2/account/user-data/')
        .get()
        .then((response) => {
          if(response?.location) {
            setBounds(response.location.bounds)
            dispatch(setLocationInfo(response.location))
          }
        }).catch((error) => {
          console.error(error)
        })
    } else {
      setBounds(notNearByBounds)
    }
  }, [])
  return bounds
}
